// import { useQuery } from "@tanstack/react-query";
import React, { useState } from "react";
import toast from "react-hot-toast";
import { TypeAnimation } from "react-type-animation";
import { ScaleLoader } from "react-spinners";
import { useForm } from "react-hook-form";

const UpdateProfileModal = ({ updateProfile, setUpdateProfile, refetch }) => {
  const { _id, name, image, email } = updateProfile;

  const [loading, setLoading] = useState(false);

  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm();

  const handleUpdateProfile = (data) => {
    const image = data.image[0];
    const formData = new FormData();
    formData.append("image", image);

    const url =
      "https://api.imgbb.com/1/upload?key=22ec5654c30a25668b99a13501e167cf";
    fetch(url, {
      method: "POST",
      body: formData,
    })
      .then((res) => res.json())
      .then((imgData) => {
        if (imgData.success) {
          console.log(imgData.data.url);
        }

        const updateUser = {
          name: data.name,
          image: imgData.data?.url,
        };
        // console.log("updateUser Info:", updateUser);

        setLoading(true);
        fetch(`https://recycle-hut-server.vercel.app/users/${_id}`, {
          method: "PUT",
          headers: {
            "content-type": "application/json",
          },
          body: JSON.stringify(updateUser),
        })
          .then((res) => res.json())
          .then((data) => {
            // console.log("response data", data);
            if (data.modifiedCount > 0) {
              setUpdateProfile(null);
              toast.success(`Your Profile Updated Successfully..`);
              setLoading(false);
              refetch();
            }
          });
      });
  };

  return (
    <div className="rounded">
      <input
        type="checkbox"
        id="update-profile-modal"
        className="modal-toggle"
      />
      <div className="modal">
        <div className="modal-box relative items-center lg:p-[20px]">
          <div className="mb-[-20px]">
            <label
              htmlFor="update-profile-modal"
              className="btn btn-sm btn-circle absolute right-3 md:mt-[3px] mr-2 hover:text-white hover:bg-red-400 hover:border-none"
              title="Close"
            >
              ✕
            </label>

            <h3 className="text-[22px] md:text-[24px] text-cyan-500 font-bold mt-0 my-transition-4">
              <TypeAnimation
                sequence={["Update Your Profile", 3000]}
                speed={45}
                cursor={true}
                repeat={Infinity}
              />
            </h3>
          </div>

          <form
            onSubmit={handleSubmit(handleUpdateProfile)}
            className="grid grid-cols-1 gap-3 mt-[33px] md:mt-[38px]"
          >
            <div className="flex flex-col gap-1 md:gap-2">
              <div className="form-control w-full">
                <label className="label">
                  <span className="label-text font-semibold">Update Name</span>
                </label>

                <input
                  type="text"
                  {...register("name")}
                  defaultValue={name}
                  className="input input-bordered w-full my-transition-7"
                  required
                />
              </div>

              <div className="form-control w-full mb-0">
                <label className="label">
                  <span className="label-text font-semibold">Update Photo</span>
                </label>

                <input
                  type="file"
                  {...register("image", {
                    required: "Please Choose a Photo",
                  })}
                  className="input input-bordered w-full p-0 borde border-slate-40 rounde my-transition-7"
                />
                {errors.image && (
                  <p className="text-error font-bold text-start mt-2">
                    {errors.image?.message}
                  </p>
                )}
              </div>

              <div className="form-control w-full">
                <label className="label">
                  <span className="label-text font-semibold">
                    Email Address
                  </span>
                </label>
                <input
                  type="text"
                  disabled
                  defaultValue={email}
                  className="input w-full input-bordered"
                  title="Emai address can not be changed"
                />
              </div>
            </div>

            <br />

            <button
              className="btn btn-accent bg-cyan-500 text-white w-full mt-[-33px] hover:font-bold"
              value="Update Profile"
            >
              {loading ? (
                <ScaleLoader color="#fff" height={16} />
              ) : (
                "Update Profile"
              )}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default UpdateProfileModal;
